<template>
    <div class="about">
         <!-- style="background: rgb(247, 250, 252)" -->
          <header style="background: rgb(247, 250, 252)" class="relative">
            <img :src="image" alt="" class="object-cover w-full h-full absolute  inset-0 op-10">
            <div style="max-width: 720px" class="mx-auto relative">
              <container class="py-8 md:py-24">
                <ul class="breadcrumbs flex mb-4">
                    <li><router-link to="/" class="text-awro-700" >{{ $t('nav.home') }}</router-link></li>
                    <li class="mx-1">/</li>
                    <li>{{ $t('general.articles') }}</li>
                    <li class="mx-1">/</li>
                    <li>{{ article.Title }}</li>
                  </ul>
                  <head-line :level="1" :size="1" :bold="true">{{ article.Title }}</head-line>
                  <small class="text-awro-700">{{ article.Category }}</small>
              </container>
            </div>
          </header>
        <container class="text-lg mb-16 -mt-6 relative">
          <div style="max-width: 720px" class="mx-auto">
            <div class="mb-12">
                <div class="w-full h-64 rounded overflow-hidden shadow">
                    <img :src="image" :alt="article.Title" class="object-cover w-full h-full">
                </div>
            </div>
            <div v-html="article.Body" class="leading-9"></div>
          </div>
         </container>
     </div>
</template>

<script>
import HeadLine from '@/components/theme/HeadLine'
import Container from '@/components/Container'
import Api from '@/api'
import {imageUrl} from '@/utils/helpers'
import {mapGetters} from 'vuex';

export default {
   name: "Article",
   components: {HeadLine, Container},
   data(){
    return {
      article: {
        Category: '',
        ImageUrl: '',
        Title: ''
      },
      background: ''
    }
   },
   async beforeRouteEnter(to, from, next) {
    const url = '/cms/article/details/' + to.params.id;
    const response = await Api.get(url);
    next(vm => vm.setData(response.data));
   },
   async beforeRouteUpdate(to) {
    const url = '/cms/article/details/' + to.params.id;
    const response = await Api.get(url);
    this.setData(response.data);
   },
  computed: {
    ...mapGetters({
        apiLocale: ['locale/API_LOCALE']
    }),
    image() {
        return imageUrl(this.article.ImageUrl);
    }
  },
  methods: {
    setData(article) {
        this.article = article;
    },
    getImage(article) {
        return imageUrl(article.ImageUrl)
    }
  },
  metaInfo () {
     let bodyContent = '';
     const body = this.article.Body; 
     if(body && Object.prototype.toString.call(body) == "[object String]") {
       bodyContent = body.toString().substr(0, 200);
     }
      return {
        title: this.$i18n.t('pages.blog.title') + ' | ' + this.article.Title,
        meta: [
          {name: 'description', content: bodyContent},
          {name: 'keywords', content: this.article.Title.toString().split(' ').join(',')},
          {property: 'og:type', content: 'article'},
          {property: 'og:title', content: this.article.Title},
          {property: 'og:description', content: bodyContent},
          {property: 'og:image', content: this.image},
          {name: 'twitter:card', content: this.image},
        ]
      }
    }
}
</script>

<style>
    .op-10 {
        opacity: 0.10
    }
</style>
